import { useEffect, useRef, useState } from "react";
import { API, API_BASEURL, SWR_CONFIG, buildUrl } from "../../../config";
import useGetSWR from "../../../hooks/useGetSWR";
import { CalendarLogo, MailIconFilled, NotificationIcon } from "../../../icons";
import { NotificationListRes } from "../../../types";
import NotificationSlideOver from "./NotificationsSlideover";
import { useRecoilState } from "recoil";
import { hasUnreadNotifications } from "../../../config/recoil/atoms";

const Notifications = () => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [unreadNotifications, setUnreadNotifications] = useRecoilState(hasUnreadNotifications);
    const [toggled, setToggled] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const url = buildUrl(API.NOTIFICATIONS_UNREAD, {}, API_BASEURL);

    const { data: notifications } = useGetSWR<NotificationListRes>(url, {
        ...SWR_CONFIG.FORMS,
        revalidateOnFocus: true,
    });

    const onClick = (value: boolean) => {
        setDisabled(true);
        setToggled(value);
        setTimeout(() => setDisabled(false), 500);
    };

    const [type, setType] = useState<"" | "conversation" | "calendar">("");

    useEffect(() => {
        if (notifications && setUnreadNotifications) {
            const newUnread = { calendar: false, conversation: false, other: false };
            if (!notifications?.count) return setUnreadNotifications(newUnread);
            newUnread.calendar = !!notifications.notification?.some((n) => n.category === 'appointment' || n.category === 'task');
            newUnread.conversation = !!notifications.notification?.some((n) => n.category === 'conversation');
            newUnread.other = !!notifications.notification?.some(
                (n) => n.category !== "conversation" && n.category !== "appointment" && n.category !== "task"
            );
            setUnreadNotifications(newUnread)
        }
    }, [notifications, setUnreadNotifications])

    return (
        <div
            ref={wrapperRef}
            className="flex flex-col items-center justify-center relative cursor-pointer z-10"
        >
            <div className="flex flex-row">
                <div
                    onClick={() => {
                        if (!disabled) {
                            setToggled(true);
                            setType("");
                        }
                    }}
                    className={"relative"}
                >
                    {unreadNotifications.other && (
                        <span className="flex h-3 w-3 absolute right-0 top-0">
                            <span className="animate-ping-slow absolute inline-flex h-full w-full rounded-full bg-color2 opacity-75 "></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-color2 border-2 md:border-color8 border-color1"></span>
                        </span>
                    )}
                    <NotificationIcon className="md:text-color7 text-color8 fill-current h-6 w-6" />
                </div>
                <div
                    onClick={() => {
                        if (!disabled) {
                            setToggled(true);
                            setType("conversation");
                        }
                    }}
                    className={"relative ml-4"}
                >
                    {unreadNotifications.conversation && (
                        <span className="flex h-3 w-3 absolute right-0 top-0">
                            <span className="animate-ping-slow absolute inline-flex h-full w-full rounded-full bg-color2 opacity-75 "></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-color2 border-2 md:border-color8 border-color1"></span>
                        </span>
                    )}
                    <MailIconFilled className="md:text-color7 text-color8 fill-current h-6 w-6" />
                </div>
                <div
                    onClick={() => {
                        if (!disabled) {
                            setToggled(true);
                            setType("calendar");
                        }
                    }}
                    className={"relative ml-4 flex items-center"}
                >
                    {unreadNotifications.calendar && (
                        <span className="flex h-3 w-3 absolute right-0 top-0">
                            <span className="animate-ping-slow absolute inline-flex h-full w-full rounded-full bg-color2 opacity-75 "></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-color2 border-2 md:border-color8 border-color1"></span>
                        </span>
                    )}
                    <CalendarLogo className="md:text-color7 text-color8 fill-current h-6 w-6" />
                </div>
            </div>
            <NotificationSlideOver open={toggled} setOpen={onClick} type={type} />
        </div>
    );
};

export default Notifications;
